import { render, staticRenderFns } from "./CompensationOrderDialog.vue?vue&type=template&id=945745a8"
import script from "./CompensationOrderDialog.vue?vue&type=script&lang=js"
export * from "./CompensationOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports